export default function RiceCooker(props: any) {
    return (
        <svg width="56" height="57" viewBox="0 0 56 57" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M13.743 10.889C13.743 10.889 9.8488 27.106 8.87638 36.6455C7.90395 46.1849 12.7706 49.0467 15.6879 49.0467H34.164C37.0812 49.0467 45.8331 50.0007 46.8055 40.4613C47.5834 32.8297 43.6893 16.6127 42.9158 12.7969C42.1423 8.98113 40.9703 7.07324 38.0537 7.07324H18.6051C15.4934 7.07324 14.0672 9.61709 13.743 10.889Z"
                stroke="black"
                strokeWidth="2"
            />
            <path d="M31.6445 29.0137H45.9537" stroke="black" strokeWidth="2" />
            <path d="M10.6582 29.0137H24.0134" stroke="black" strokeWidth="2" />
            <rect x="24.0137" y="26.1519" width="7.63154" height="19.0789" rx="3.81577" stroke="black" strokeWidth="2" />
            <ellipse cx="27.8298" cy="12.797" rx="1.90788" ry="1.90789" stroke="black" strokeWidth="2" />
            <ellipse cx="27.8298" cy="20.4284" rx="1.90788" ry="1.90789" stroke="black" strokeWidth="2" />
        </svg>
    );
}
